/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Daily_Col_CodeInputs */

const vi_expense_daily_col_code = /** @type {(inputs: Expense_Daily_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã`)
};

/**

* @param {Expense_Daily_Col_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_daily_col_code = /** @type {((inputs?: Expense_Daily_Col_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Daily_Col_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_daily_col_code(inputs)
});